<div
  *ngIf="isVisible"
  class="trial-banner"
  role="status"
  aria-live="polite">
  <div class="trial-banner__icon" aria-hidden="true">
    <i class="fas fa-hourglass-half"></i>
  </div>
  <div class="trial-banner__body">
    <p class="trial-banner__text">{{ label }}</p>
  </div>
  <a class="trial-banner__cta" href="#upgrade-plan">{{ cta }}</a>
</div>
